export default "__VITE_ASSET__034c89ad__"